import Transforms from './transforms'

const endpoints = {
    list: {
        path: '/entities',
    },
    schema: {
        path: '/entities/:entityKey/schema',
        transform: Transforms.schema,
    },
    order: {
        method: 'PUT',
        path: '/entities/:entityKey/schema/fields',
    },
    transforms: {
        path: '/entities/transforms',
        transform: Transforms.transforms,
    },
    styles: {
        path: '/entities/styles',
        transform: Transforms.styles,
    },
    validators: {
        path: '/entities/validators',
        transform: Transforms.validators,
    },
    create: {
        method: 'POST',
        path: '/entities/:entityKey/schema/fields',
        transform: Transforms.create,
    },
    update: {
        method: 'PUT',
        path: '/entities/:entityKey/schema/fields/:fieldKey',
    },
    delete: {
        method: 'DELETE',
        path: '/entities/:entityKey/schema/fields/:fieldKey',
    },
    merge: {
        method: 'POST',
        path: '/entities/:entityKey/schema/merge',
    },
    search: {
        path: '/outputs/:entityKey/search',
    },
    matchRuleCreate: {
        method: 'POST',
        path: '/entities/:entityKey/schema/match-rules',
    },
    matchRuleUpdate: {
        method: 'PUT',
        path: '/entities/:entityKey/schema/match-rules/:ruleKey',
    },
    matchRuleDelete: {
        method: 'DELETE',
        path: '/entities/:entityKey/schema/match-rules/:ruleKey',
    },
}

export default {
    name: 'entities',
    endpoints,
}
